module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/ruler-a408dc4e17513c7b71b698b876883f16.svg";